import { render, staticRenderFns } from "./JobsForm.vue?vue&type=template&id=3b552b56&"
import script from "./JobsForm.vue?vue&type=script&lang=js&"
export * from "./JobsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "JobsForm.vue"
export default component.exports